import {connect} from 'react-redux';
import * as DisplayMode from 'constants/DisplayMode';

import Menu from '../Menu.jsx';

function select(state, props) {
    const sports = state.application.getIn(['menu', 'sports']);

    let sportId = undefined, leagueId = undefined;
    if (props.params) {
        sportId = props.params.sportId;
        leagueId = props.params.leagueId;
    }

    let displayMode = {type: DisplayMode.ALL};

    if (leagueId === undefined && sportId) {
        displayMode.type = DisplayMode.SPORT;
        displayMode.id = parseInt(sportId);
    } else if (leagueId && sportId) {
        displayMode.type = DisplayMode.LEAGUE;
        displayMode.id = parseInt(leagueId);
    }

    return {
        ...props,
        sports,
        displayMode,
        showWidget: true,
        user: state.auth.get('user'),
        countryCode: state.application.get('countryCode')
    };
}

export default connect(select)(Menu);



// WEBPACK FOOTER //
// ./js/sport-betting/components/menu/preMatch/Menu.jsx